module.exports = __webpack_public_path__ + "img/cancel.634076eb.png";